// import { pipe } from "fp";

import {
  default as AntTable,
  TableProps as AntTableProps,
} from "antd/lib/table";

import { FilterDropdownProps } from "antd/lib/table/interface";

import React from "react";
import styled from "styled-components";

import * as Animation from "~/Animation";
import * as Color from "~/Color";
import * as Shadow from "~/Shadow";
import * as Typography from "~/Typography";

export function Table<A extends Record<string, unknown>>(
  props: AntTableProps<A>
) {
  return (
    <Table.Container>
      <AntTable<A>
        pagination={{ showSizeChanger: true, position: ["bottomCenter"] }}
        {...props}
        showSorterTooltip={false}
      />
    </Table.Container>
  );
}

export namespace Table {
  export const Container = styled.div`
    .ant-table {
      color: inherit;
      font-size: ${() => Typography.FontSize.data()};
      line-height: 1em;
    }

    td.ant-table-cell {
      background: none;
    }

    .ant-table-row {
      ${() => Animation.Transition.styles(Animation.medium())}
      &:hover {
        ${() => Shadow.Box.styles(Shadow.medium())};
      }
    }

    .ant-table-thead > tr > th {
      border-bottom: 1px solid ${() => Color.veryWhiteGrey()};
      font-size: ${() => Typography.FontSize.base()};
      font-weight: bold;
      white-space: nowrap !important;
    }

    .ant-table-thead > tr > th,
    .ant-table-tbody > tr.ant-table-row:hover > td {
      background: ${() => Color.almostWhite()} !important;
    }

    .ant-table-tbody > tr > td {
      border-bottom: 1px solid ${() => Color.veryWhiteGrey()};
      white-space: nowrap !important;
    }

    .ant-table-column-sorter-up,
    .ant-table-column-sorter-down {
      color: ${() => Color.translucentBlack(0.5)};
    }

    .ant-table-column-sorter-up.active,
    .ant-table-column-sorter-down.active {
      color: ${() => Color.azure()};
    }

    .ant-pagination li {
      & div.ant-select-item.ant-select-item-option {
        background: none !important;
        .ant-select-item-option-content {
          &,
          &:hover {
            color: ${() => Color.black()} !important;
          }
        }
      }

      &,
      & * {
        color: ${() => Color.black()} !important;
        border-color: ${() => Color.veryWhiteGrey()} !important;
        transition: ${() =>
          Animation.Transition.style(Animation.fast())} !important;
      }

      &.ant-pagination-item-active,
      &:hover,
      &:active {
        &,
        & * {
          color: ${() => Color.azure()} !important;
          border-color: ${() => Color.azure()} !important;
          transition: ${() =>
            Animation.Transition.style(Animation.fast())} !important;
        }
      }

      &.ant-pagination-disabled {
        &,
        & *,
        &:hover,
        &:hover *,
        &:active,
        &:active * {
          color: ${() => Color.veryWhiteGrey()} !important;
          border-color: ${() => Color.veryWhiteGrey()} !important;
          box-shadow: none;
        }
      }
    }
  `;

  export namespace Filter {
    export namespace Dropdown {
      export type Props = FilterDropdownProps;
    }
  }
}
